<template>
  <div>
    <notifications position="top center"></notifications>

    <button @click="openModal()" type="button" class="ec-action-btn ec-action-btn--primary">
      <i class="fas fa-calendar" aria-hidden="true"></i>
      <span>Add event</span>
    </button>

    <Teleport to="body">
      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-if="isOpen" class="fixed inset-0 overflow-y-auto" style="z-index: 1000" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full sm:w-full sm:p-6">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  {{ isEditing ? 'Edit Event' : 'Add Event' }}
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Title</label>
                  <div class="mt-1 flex items-center space-x-2">
                    <input type="text" v-model="form.title" id="quantity" class="flex-1 min-w-0 block w-full px-3 py-3 rounded-md focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm border-gray-300">
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Event Type</label>
                  <div class="mt-1 flex items-center space-x-2">
                    <select id="day_selection" v-model="day_selection" autocomplete="" class="flex-1 min-w-0 block w-full px-3 py-3 rounded-md focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm border-gray-300">
                      <option value="single">Single Day</option>
                      <option value="multiple">Multiple Day</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="begins_at" class="block text-sm font-medium text-gray-700">Start Date</label>
                  <div class="mt-1 flex items-center space-x-2">
                    <flat-pickr v-model="form.begins_at" :config="dateTimeConfig" class="flex-1 min-w-0 block w-full px-3 py-3 rounded-md focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm border-gray-300"></flat-pickr>
                  </div>
                </div>
              </div>

              <div class="my-3" v-if="day_selection == 'multiple'">
                <div>
                  <label for="end_date" class="block text-sm font-medium text-gray-700">End Date</label>
                  <div class="mt-1 flex items-center space-x-2">
                    <flat-pickr v-model="form.end_date" :config="dateTimeConfig" class="flex-1 min-w-0 block w-full px-3 py-3 rounded-md focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm border-gray-300"></flat-pickr>
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Address</label>
                  <div class="mt-1">
<!--                    <flat-pickr v-model="form.date_received" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"></flat-pickr>-->
<!--                    <vue-google-autocomplete-->
<!--                        :value="form.fullAddress"-->
<!--                        id="startLocationField"-->
<!--                        classname="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"-->
<!--                        placeholder="Enter address"-->
<!--                        v-on:placechanged="getAddressData"-->
<!--                        v-on:keypress="resetAddressOnKeyPress"-->
<!--                        country="us"-->
<!--                    />-->
                    <GMapAutocomplete
                        :value="form.fullAddress"
                        placeholder="Type to search for address"
                        @place_changed="getAddressData"
                        :class="`flex-1 min-w-0 block w-full px-3 py-3 rounded-md focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm border-gray-300`"
                    >
                    </GMapAutocomplete>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="mt-5 sm:mt-4 flex flex-col sm:flex-row-reverse sm:space-x-3 sm:space-x-reverse gap-3">
              <button @click="createOrUpdate" type="button" class="w-full sm:w-auto inline-flex items-center justify-center text-center text-sm uppercase px-6 py-3 border-2 border-transparent font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-200 rounded-full">
                <i class="fas fa-check mr-2"></i> {{ isEditing ? 'Save' : 'Add' }}
              </button>
              <button @click="isOpen = false" type="button" class="w-full sm:w-auto inline-flex items-center justify-center text-center text-sm uppercase px-6 py-3 border-2 border-transparent font-medium shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-200 rounded-full">
                <i class="fas fa-ban mr-2"></i> Cancel
              </button>
          </div>
        </div>
      </div>
      </div>

    </transition>
    </Teleport>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'AddCampaignEventButton',
  components: {
    flatPickr
  },
  props: {
    campaignId: null,
    campaignEventId: null,
    campaignName: null,
  },
  data() {
    return {
      day_selection: 'single',
      isOpen: false,
      isEditing: false,
      dateTimeConfig: {
        enableTime: true,
        dateFormat: "Y-m-d h:i K",
        time_24hr: false,
      },
      form: {
        title: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        description: null,
        begins_at: null,
        end_date: null,
        campaign_id: this.campaignId,
        id: null,
        fullAddress: null,
      }
    }
  },
  methods: {
    openModal(event = null) {
      this.isOpen = true;
      if (event) {
        this.isEditing = true;
        this.form = { ...event };
        this.day_selection = event.end_date ? 'multiple' : 'single';
        // Set the full address for the Google Maps Autocomplete
        this.form.fullAddress = `${event.address || ''} ${event.address2 || ''} ${event.city || ''} ${event.state || ''} ${event.zip || ''}`.trim();
      } else {
        this.isEditing = false;
        this.resetForm();
      }
    },
    setOpenToFalse() {
      this.isOpen = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        title: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        description: null,
        begins_at: null,
        end_date: null,
        campaign_id: this.campaignId,
        id: null,
        fullAddress: null,
      };
      this.day_selection = 'single';
    },
    createOrUpdate() {
      if (!this.form.begins_at){
        this.$notify({
          text: 'Start date is required',
          type: 'error',
        })
        return
      }
      if (!this.form.address){
        this.$notify({
          text: 'Address is required',
          type: 'error',
        })
        return
      }
      if (!this.form.title){
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      const url = this.isEditing ? `/campaign-event/update/${this.form.id}` : '/campaign-event/create';
      axios.post(url, this.form)
          .then(response => {
            this.$notify({
              text: `Campaign event successfully ${this.isEditing ? 'updated' : 'added'}`,
              type: 'success',
            })
            this.isOpen = false
            this.$emit('event-added')
            this.resetForm()
          })
          .catch(error => {
            console.error('Error saving event:', error);
            this.$notify({
              text: `Failed to ${this.isEditing ? 'update' : 'add'} event`,
              type: 'error',
            })
          })
    },
    action() {
      return this.campaignEventId ? 'updated' : 'created'
    },
    getAddressData: function (addressData) {
      if (addressData && addressData.address_components) {
        this.form.address = '';
        this.form.city = '';
        this.form.state = '';
        this.form.zip = '';

        for (let component of addressData.address_components) {
          const componentType = component.types[0];

          switch (componentType) {
            case "street_number":
              this.form.address = `${component.long_name} ${this.form.address}`;
              break;
            case "route":
              this.form.address += component.short_name;
              break;
            case "locality":
              this.form.city = component.long_name;
              break;
            case "administrative_area_level_1":
              this.form.state = component.short_name;
              break;
            case "postal_code":
              this.form.zip = component.long_name;
              break;
          }
        }

        this.form.fullAddress = addressData.formatted_address;
      }
    },

    resetAddressOnKeyPress: function (changes) {
      //console.log(changes)
    },
    eventsUrl() {
      return '/campaign/'+this.campaignId+'/event/'
    }
  }
}
</script>

